import { defineStore } from "pinia";
import { ref } from "vue";
import { useToast } from "vue-toastification";
import campaignService from "@/services/campaign";

export const useCampaignsStore = defineStore("campaigns", () => {
  const toast = useToast();
  const loading = ref(false);

  async function fetchAllCampaignsGrid(companyId) {
    loading.value = true;
    try {
      const res = await campaignService.getAllCampaignsGrid(companyId);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function addCampaign(payload) {
    loading.value = true;
    try {
      const res = await campaignService.addCampaign(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function editCampaign(payload) {
    loading.value = true;
    try {
      const res = await campaignService.editCampaign(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function deleteCampaign(payload) {
    loading.value = true;
    try {
      const res = await campaignService.deleteCampaign(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchCampaignById(payload) {
    loading.value = true;
    try {
      const res = await campaignService.getCampaignById(payload);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  return {
    loading,
    fetchAllCampaignsGrid,
    addCampaign,
    editCampaign,
    deleteCampaign,
    fetchCampaignById,
  };
});
